<template>
    <el-dialog :close-on-click-modal="false" title="请选择合同类型" width="42%" v-bind="$attrs" v-on="$listeners" class="h-dialog3 ljjtitlesblue">
		<div class="leaderBox" v-if="showOrhidelist">
			<div class="newtext">新手指引</div>
			<img src="../../assets/images/maskClose.png" class="closeIt" @click="closeItlist">
			<img src="../../assets/images/xzht1.png" class="steps step6" v-if="statuslist==6">
			<img src="../../assets/images/xzht2.png" class="steps step7" v-if="statuslist==7">
			<div class="stepbtn1" @click="nextSteplist(statuslist)">
				{{statuslist==6?"下一步":statuslist==7?"我知道了":"我知道了"}}
			</div>
			<div class="bottomTip2">
				<el-checkbox v-model="checkedlist">下次不再提示</el-checkbox>
			</div>
		</div>
        <div class="h-checkType">
            <ul>
                <li v-for="(item,index) in hetonglist" :key="index">
                    <div :class="{'h-active':hetongdex==index}" @click="hetongbtn(index)">
                        <h1>{{item.title}}</h1>
                        <p>{{item.desc}}</p>
                        <i>
                            <img v-if="index==0" src="../../assets/images/h-hetong-type-icon1.png" alt="">
                            <img v-if="index==1" src="../../assets/images/h-hetong-type-icon2.png" alt="">
                        </i>
                    </div>
                </li>
            </ul>
        </div>
        <div slot="footer" class="dialog-footer">
        <el-button class="h-btn h-formBtn h-bgblue2" @click="queren">确认选择 </el-button>
        </div>
    </el-dialog>
</template>
<script>
	import ss from "../../api/SystemService";
export default {
    data(){
        return {
            //弹框
            dialogFormVisible:true,
            hetongdex:0,
            hetonglist:[
                {
                    title:"线下合同",
                    desc:'线下所签署的合同，提供电子版上传',
                },
                {
                    title:"LEG合同",
                    desc:'LEG系统签署的合同，通过合同号关联',
                }
            ],
			toshowlist:"htlb",
			statuslist:6,
			checkedlist:true,
			showOrhidelist:false
        }
    },
	mounted() {

	},
    methods:{
		showzhezhao(){
			ss.salesList.toshow(this.toshowlist).then(rd => {
				console.log(rd)
			    if(rd == false){
			        this.showOrhidelist = false;
			    }else{
			        this.showOrhidelist = true;
			    }
			})
		},
        hetongbtn(index){
            this.hetongdex = index;
        },
        queren(){
            if(this.hetongdex==0){
                this.$router.push("/contract-new2")
                this.dialogFormVisible=false
            }else{
                this.$router.push("/contract-new1")
                this.dialogFormVisible=false
            }
            this.$emit('imgfalse1');
        },
		nextSteplist(i){
			if(this.statuslist ==6){
					this.statuslist = 7;
			}else if(this.statuslist ==7){
				if(this.checkedlist){
					ss.salesList.toshow(this.toshowlist,this.checkedlist).then(rd => {
						console.log(rd)
						this.showOrhidelist = false;
					})
				}else{
					ss.salesList.toshow(this.toshowlist,this.checkedlist).then(rd => {
						console.log(rd)
						this.showOrhidelist = false;
					})
				}
			}
		},
		// 关闭新手引导页
		closeItlist(){
			this.showOrhidelist = false;
			if(this.checkedlist){
				ss.salesList.toshow(this.toshowlist,this.checkedlist).then(rd => {
					console.log(rd)
					this.showOrhidelist = false;
				})
			}else{
				ss.salesList.toshow(this.toshowlist,this.checkedlist).then(rd => {
					console.log(rd)
					this.showOrhidelist = false;
				})
			}
		},
    },
	created() {
		this.showzhezhao()
	},
    props: {
        dialogVisible: {
            type: Boolean,
        },
    }
}
</script>
<style scoped lang="scss">
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
.bottomTip2{
	position: absolute;
	left: 50%;
	bottom: 0.1rem;
	transform: translateX(-50%);
}
.leaderBox{
	width: 100%;
	height: 100%;
	background-color: rgba(0,0,0,0.4);
	position: fixed;
	z-index: 99999;
	overflow: hidden;
	top: 0;
	left: 0;
	.leaderbg{
		width: 100%;
		height: 100%;
	}
	.steps{
		position: absolute;
		z-index: 1;
	}
	.step6{
		top: 2.7rem;
		width: 11.6rem;
		height: 4.3rem;
		left: 2.3rem;
	}
	.step7{
		top: 7.25rem;
		width: 4.7rem;
		height: 1rem;
		left: 8.6rem;
	}
	.stepbtn1{
		width: 1.9rem;
		height: 0.6rem;
		border: 0.03rem solid #FFFFFF;
		background-color: rgba(0,0,0,0.1);
		border-radius: 5px;
		display: flex;
		justify-content: center;
		line-height: 0.5rem;
		position: absolute;
		z-index: 99;
		bottom: 0.45rem;
		left: 50%;
		transform: translateX(-50%);
		font-size: 0.27rem;
		letter-spacing: 2px;
		color: white;
		cursor: pointer;
	}
	.closeIt{
		width: 0.3rem;
		height: 0.3rem;
		position: absolute;
		top: 0.2rem;
		right: 0.2rem;
		cursor: pointer;
	}
}
</style>